import React, {useState} from 'react';
import {SwitchBasic} from "../../switch/SwitchBasic";
import InputSingle from "../../input/InputSingle";
import {deleteFiled, updateFiled} from "../../../api/field/FieldService";
import {handleActiveToast} from "../../sonner/ToastBasic";
import draggable from "../../../resources/icon/draggable.png";
import FieldFormatDisplay from "./FieldFormatDisplay";

/**
 * `필드 `텍스트에리어
 * */


function FieldText({each, setFlag, dragHandleProps}) {
    const [modify, setModify] =useState(false);
    const [data, setData] =useState(each);
    const update =()=>{
        setModify(true)
    }
    async function save(){
        const response = await updateFiled(data);
        if (response.status===200) {
            setModify(false)
            setFlag(true);
            handleActiveToast({description:"",message:"수정되었습니다.", labelListener:()=>{}})
        }else if(response.response.status===401){
            handleActiveToast({description:"",message:"로그인 하세요.", labelListener:()=>{}})
        }else if(response.response.status===403){
            handleActiveToast({description:"",message:"권한이 없습니다.", labelListener:()=>{}})
        }
    }


    async function deleteItem(){
        if(window.confirm("삭제 하시겠습니까")) {
            const response = await deleteFiled(data.id);
            if (response.status === 200) {
                setModify(false)
                setFlag(true);
                handleActiveToast({
                    description: "", message: "삭제 되었습니다.", labelListener: () => {
                    }
                })
            } else if (response.response.status === 401) {
                handleActiveToast({
                    description: "", message: "로그인 하세요.", labelListener: () => {
                    }
                })
            } else if (response.response.status === 403) {
                handleActiveToast({
                    description: "", message: "권한이 없습니다.", labelListener: () => {
                    }
                })
            }
        }
    }

    return (
        <>
            <th className="fieldset-th relative">
                {modify ? (
                    <InputSingle target={'title'}  data={{ data: data, setData: setData }} required={true} className={'field-add'}/>
                ):(<span className={"input-label"}>{each.title}</span>)}

                <img
                    src={draggable}
                    className="draggable-icon"
                    {...dragHandleProps}
                />
            </th>
            <td colSpan={3} className="fieldset-td">
                {modify ? (
                    <textarea
                        type={"text"}
                        className={`field-set-text no-resize over-hidden ${data.isRequired ? "border-red" : ""}`}
                        readOnly={true}
                        placeholder={"장문 텍스트"}
                    />
                ) : (
                    <FieldFormatDisplay type="TEXT" />
                )}

                <div className="inline-block relative">
                    {modify ? (
                        <SwitchBasic
                            onCheckedChange={(checked) => {
                                setData((prev) => ({
                                    ...prev,
                                    isRequired: checked,
                                }));
                            }}
                            className={"absolute top-[-55px] left-10"} defaultChecked={each.isRequired}/>
                    ):(<></>)}
                </div>


                {modify ? (
                    <>
                        <button className="list-btn float-right hover-black ml-auto mt-[2px] bg-cancel-important" onClick={()=>setModify(false)}>취소</button>
                        <button className="list-btn float-right hover-black ml-auto mt-[2px] bg-save-important" onClick={save}>저장 </button>
                    </>

                ) : (
                    <>
                        <button className="list-btn float-right hover-black ml-auto mt-[2px] bg-delete-important" onClick={deleteItem}>삭제</button>
                        <button className="list-btn float-right hover-black ml-auto mt-[2px] " onClick={update}>수정</button>
                    </>
                )}

            </td>
        </>
    );
}

export default FieldText;